import React from 'react'

const divStyle = {
  width: '100%',
  height: '100%',
  backgroundColor: '#cccccc',
  borderRadius: '50%',
  color: '#fff',
  textAlign: 'center',
  verticalAlign: 'middle'
}

export default ({ user, style }) => (
  user.pictureUrl
    ? <img style={style} src={user.pictureUrl} />
    : <div style={{...divStyle, ...style}}>
      {user.first_name[0].toUpperCase() + ' ' +
        user.last_name[0].toUpperCase()}
    </div>
)